import axios from 'axios'
import S3Api from '@/api/s3'
const server = process.env.VUE_APP_API_URL || ''
const api = `${server}/api/artwork`

const loadArtworks = () => {
  return axios.get(api)
}

const loadArtistArtworks = () => {
  return axios.get(api + '/artist')
}

const getArtworkProducts = (artworkCode) => {
  return axios.get(api + '/products/' + artworkCode )
}

const nextArtworkSequence = (artistCode) => {
  return axios.get(api + '/nextArtworkSequence/' + artistCode )
}

export default {
  loadArtworks,
  loadArtistArtworks,
  nextArtworkSequence,
  getArtworkProducts
}
